module.exports = __webpack_public_path__ + "static/media/sydnie-yu.1157bb5e.png";